// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/trading.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../buf/validate/validate_pb";
import type { AccountType, BillingFailureReason } from "./billing_pb";
import { file_common_billing } from "./billing_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/trading.proto.
 */
export const file_common_trading: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_common_billing]);

/**
 * Per-pair, per-provider streaming configuration. Replaces the older
 * `repeated TickerProvider providers` field — region was previously a
 * global env var (ITICK_REGION) but had to move onto each pair so a
 * single iTick connection can serve forex (GB) alongside crypto (BA).
 *
 * @generated from message common.PairProviderConfig
 */
export type PairProviderConfig = Message<"common.PairProviderConfig"> & {
  /**
   * @generated from field: common.TickerProvider provider = 1;
   */
  provider: TickerProvider;

  /**
   * Optional because providers without a region concept (TwelveData,
   * OKX) leave it unset. Validation happens server-side: iTick + crypto
   * requires one of BA/BT/PB; iTick + forex requires GB.
   *
   * @generated from field: optional common.TickerProviderRegion region = 2;
   */
  region?: TickerProviderRegion;
};

/**
 * Describes the message common.PairProviderConfig.
 * Use `create(PairProviderConfigSchema)` to create a new message.
 */
export const PairProviderConfigSchema: GenMessage<PairProviderConfig> = /*@__PURE__*/
  messageDesc(file_common_trading, 0);

/**
 * Trading-schedule shape stored on `Pair.schedule` (jsonb in PG, typed
 * proto on the wire). Forex pairs supply this to gate trading; crypto
 * pairs leave it empty / always-open. Used by the SCHEDULE_ANALYSIS
 * background job to suggest schedules from M1-candle gaps.
 *
 * @generated from message common.ScheduleSegment
 */
export type ScheduleSegment = Message<"common.ScheduleSegment"> & {
  /**
   * "HH:MM" or "HH:MM:SS" — UTC. "24:00" allowed as the close of a day.
   *
   * @generated from field: string open = 1;
   */
  open: string;

  /**
   * @generated from field: string close = 2;
   */
  close: string;
};

/**
 * Describes the message common.ScheduleSegment.
 * Use `create(ScheduleSegmentSchema)` to create a new message.
 */
export const ScheduleSegmentSchema: GenMessage<ScheduleSegment> = /*@__PURE__*/
  messageDesc(file_common_trading, 1);

/**
 * @generated from message common.DaySchedule
 */
export type DaySchedule = Message<"common.DaySchedule"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: repeated common.ScheduleSegment segments = 2;
   */
  segments: ScheduleSegment[];
};

/**
 * Describes the message common.DaySchedule.
 * Use `create(DayScheduleSchema)` to create a new message.
 */
export const DayScheduleSchema: GenMessage<DaySchedule> = /*@__PURE__*/
  messageDesc(file_common_trading, 2);

/**
 * @generated from message common.Holiday
 */
export type Holiday = Message<"common.Holiday"> & {
  /**
   * "YYYY-MM-DD" UTC.
   *
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message common.Holiday.
 * Use `create(HolidaySchema)` to create a new message.
 */
export const HolidaySchema: GenMessage<Holiday> = /*@__PURE__*/
  messageDesc(file_common_trading, 3);

/**
 * @generated from message common.PairSchedule
 */
export type PairSchedule = Message<"common.PairSchedule"> & {
  /**
   * Keys: "mon", "tue", "wed", "thu", "fri", "sat", "sun". Days absent
   * from the map are treated as "always open".
   *
   * @generated from field: map<string, common.DaySchedule> weekly = 1;
   */
  weekly: { [key: string]: DaySchedule };

  /**
   * @generated from field: repeated common.Holiday holidays = 2;
   */
  holidays: Holiday[];
};

/**
 * Describes the message common.PairSchedule.
 * Use `create(PairScheduleSchema)` to create a new message.
 */
export const PairScheduleSchema: GenMessage<PairSchedule> = /*@__PURE__*/
  messageDesc(file_common_trading, 4);

/**
 * @generated from message common.PayoutBucketValues
 */
export type PayoutBucketValues = Message<"common.PayoutBucketValues"> & {
  /**
   * @generated from field: string short = 1;
   */
  short: string;

  /**
   * @generated from field: string mid = 2;
   */
  mid: string;

  /**
   * @generated from field: string long = 3;
   */
  long: string;
};

/**
 * Describes the message common.PayoutBucketValues.
 * Use `create(PayoutBucketValuesSchema)` to create a new message.
 */
export const PayoutBucketValuesSchema: GenMessage<PayoutBucketValues> = /*@__PURE__*/
  messageDesc(file_common_trading, 5);

/**
 * @generated from message common.PayoutBucketOverride
 */
export type PayoutBucketOverride = Message<"common.PayoutBucketOverride"> & {
  /**
   * @generated from field: optional string short = 1;
   */
  short?: string;

  /**
   * @generated from field: optional string mid = 2;
   */
  mid?: string;

  /**
   * @generated from field: optional string long = 3;
   */
  long?: string;
};

/**
 * Describes the message common.PayoutBucketOverride.
 * Use `create(PayoutBucketOverrideSchema)` to create a new message.
 */
export const PayoutBucketOverrideSchema: GenMessage<PayoutBucketOverride> = /*@__PURE__*/
  messageDesc(file_common_trading, 6);

/**
 * @generated from message common.LowVolOverrideMessage
 */
export type LowVolOverrideMessage = Message<"common.LowVolOverrideMessage"> & {
  /**
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional int32 percentile = 2;
   */
  percentile?: number;

  /**
   * @generated from field: optional int32 minutes_in = 3;
   */
  minutesIn?: number;

  /**
   * @generated from field: optional int32 minutes_out = 4;
   */
  minutesOut?: number;

  /**
   * @generated from field: optional string payout_cap = 5;
   */
  payoutCap?: string;

  /**
   * @generated from field: optional int32 min_expiration_seconds = 6;
   */
  minExpirationSeconds?: number;

  /**
   * @generated from field: optional int32 min_history_days = 7;
   */
  minHistoryDays?: number;
};

/**
 * Describes the message common.LowVolOverrideMessage.
 * Use `create(LowVolOverrideMessageSchema)` to create a new message.
 */
export const LowVolOverrideMessageSchema: GenMessage<LowVolOverrideMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 7);

/**
 * @generated from message common.PairMessage
 */
export type PairMessage = Message<"common.PairMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string base_asset = 2;
   */
  baseAsset: string;

  /**
   * @generated from field: string quote_asset = 3;
   */
  quoteAsset: string;

  /**
   * @generated from field: string symbol = 4;
   */
  symbol: string;

  /**
   * @generated from field: common.AssetType type = 5;
   */
  type: AssetType;

  /**
   * @generated from field: bool is_trading_enabled = 6;
   */
  isTradingEnabled: boolean;

  /**
   * @generated from field: bool is_streaming = 7;
   */
  isStreaming: boolean;

  /**
   * @generated from field: bool is_otc = 8;
   */
  isOtc: boolean;

  /**
   * @generated from field: bool is_admin_enabled = 11;
   */
  isAdminEnabled: boolean;

  /**
   * @generated from field: int32 price_precision = 12;
   */
  pricePrecision: number;

  /**
   * @generated from field: optional common.PairSchedule schedule = 13;
   */
  schedule?: PairSchedule;

  /**
   * @generated from field: repeated common.TradingPeriodMessage bet_settings = 14;
   */
  betSettings: TradingPeriodMessage[];

  /**
   * Stats (populated in admin list views)
   *
   * @generated from field: optional int32 total_bets = 15;
   */
  totalBets?: number;

  /**
   * @generated from field: optional string turnover = 16;
   */
  turnover?: string;

  /**
   * @generated from field: optional string payouts = 17;
   */
  payouts?: string;

  /**
   * @generated from field: optional string avg_bet = 18;
   */
  avgBet?: string;

  /**
   * @generated from field: optional string ggr = 19;
   */
  ggr?: string;

  /**
   * @generated from field: optional string rtp = 20;
   */
  rtp?: string;

  /**
   * @generated from field: optional string win_rate = 21;
   */
  winRate?: string;

  /**
   * @generated from field: optional int32 min_ttl = 22;
   */
  minTtl?: number;

  /**
   * @generated from field: optional int32 max_ttl = 23;
   */
  maxTtl?: number;

  /**
   * Ticks-per-second emitted by the streaming pipeline for this pair.
   * Drives both real-data sub/super-sampling (TpsPacer) and the OTC
   * generator's per-tick interval. Default 4 = one tick every 250ms.
   * Moved off OTCConfig in 2026-04-30 — TPS now lives on Pair so it's
   * shared between OTC and real-data sources.
   *
   * @generated from field: int32 tps = 27;
   */
  tps: number;

  /**
   * Real-time provider feeding this pair, plus an optional region/venue
   * (only iTick uses it today). Unset = pair is not streamed even if
   * `is_streaming` is true. Was originally a list (`provider_configs`)
   * but multi-provider per pair was never used in practice — flattened
   * to a single optional config in 2026-04-30 so admin UI and the
   * ticker worker stop carrying the array shape.
   *
   * @generated from field: optional common.PairProviderConfig provider_config = 29;
   */
  providerConfig?: PairProviderConfig;

  /**
   * When true (default), TpsPacer pads under-rate provider feeds with
   * synthetic ticks so the pair always emits exactly `tps` ticks/sec.
   * When false, the pacer is bypassed: upstream ticks are forwarded 1:1
   * and gaps stay gaps.
   *
   * @generated from field: bool has_synthetick = 30;
   */
  hasSynthetick: boolean;

  /**
   * Active OTC generator version for this pair. Allowed values: 1, 3, 4.
   * Default 4 — the Heston engine. Switching this triggers OTC worker
   * hot-reload; the new generator is instantiated using the OTCConfig row
   * matching (pair_id, version).
   *
   * @generated from field: int32 otc_generator_version = 31;
   */
  otcGeneratorVersion: number;

  /**
   * Pair-level bet settings (single value for all durations).
   *
   * @generated from field: string payout_percent = 32;
   */
  payoutPercent: string;

  /**
   * @generated from field: string min_raise_points = 33;
   */
  minRaisePoints: string;

  /**
   * @generated from field: int32 min_duration_seconds = 34;
   */
  minDurationSeconds: number;

  /**
   * @generated from field: int32 max_duration_seconds = 35;
   */
  maxDurationSeconds: number;

  /**
   * @generated from field: repeated int32 preset_durations = 36;
   */
  presetDurations: number[];

  /**
   * @generated from field: optional string margin_percent = 37;
   */
  marginPercent?: string;

  /**
   * @generated from field: optional string real_ggr = 38;
   */
  realGgr?: string;

  /**
   * @generated from field: optional string bonus_ggr = 39;
   */
  bonusGgr?: string;

  /**
   * @generated from field: optional string win_rate_by_volume = 40;
   */
  winRateByVolume?: string;

  /**
   * @generated from field: optional string effective_payout_percent = 41;
   */
  effectivePayoutPercent?: string;

  /**
   * @generated from field: optional string refund_percent = 42;
   */
  refundPercent?: string;

  /**
   * @generated from field: optional int32 players = 43;
   */
  players?: number;

  /**
   * @generated from field: optional string bonus_turnover_share = 44;
   */
  bonusTurnoverShare?: string;

  /**
   * @generated from field: optional string real_turnover = 45;
   */
  realTurnover?: string;

  /**
   * @generated from field: optional string bonus_turnover = 46;
   */
  bonusTurnover?: string;

  /**
   * @generated from field: optional string forfeited_amount = 47;
   */
  forfeitedAmount?: string;

  /**
   * @generated from field: optional string win_stake = 48;
   */
  winStake?: string;

  /**
   * @generated from field: optional string win_profit = 49;
   */
  winProfit?: string;

  /**
   * @generated from field: optional string returned_stake = 50;
   */
  returnedStake?: string;

  /**
   * @generated from field: optional string refund_amount = 51;
   */
  refundAmount?: string;

  /**
   * @generated from field: optional string group_id = 52;
   */
  groupId?: string;

  /**
   * @generated from field: optional common.PayoutBucketOverride payout_base_override = 53;
   */
  payoutBaseOverride?: PayoutBucketOverride;

  /**
   * @generated from field: optional common.LowVolOverrideMessage low_vol_override = 54;
   */
  lowVolOverride?: LowVolOverrideMessage;

  /**
   * @generated from field: optional common.PairSchedule low_vol_schedule_override = 55;
   */
  lowVolScheduleOverride?: PairSchedule;
};

/**
 * Describes the message common.PairMessage.
 * Use `create(PairMessageSchema)` to create a new message.
 */
export const PairMessageSchema: GenMessage<PairMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 8);

/**
 * @generated from message common.TradingPeriodMessage
 */
export type TradingPeriodMessage = Message<"common.TradingPeriodMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: int32 ttl = 3;
   */
  ttl: number;

  /**
   * @generated from field: optional string timeframe = 4;
   */
  timeframe?: string;

  /**
   * @generated from field: int32 win_percentage = 5;
   */
  winPercentage: number;

  /**
   * @generated from field: string min_raise_points = 6;
   */
  minRaisePoints: string;
};

/**
 * Describes the message common.TradingPeriodMessage.
 * Use `create(TradingPeriodMessageSchema)` to create a new message.
 */
export const TradingPeriodMessageSchema: GenMessage<TradingPeriodMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 9);

/**
 * @generated from message common.BetRuleMessage
 */
export type BetRuleMessage = Message<"common.BetRuleMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string pair_id = 2;
   */
  pairId?: string;

  /**
   * @generated from field: common.BetTimeMode time_mode = 3;
   */
  timeMode: BetTimeMode;

  /**
   * @generated from field: int32 min_seconds = 4;
   */
  minSeconds: number;

  /**
   * @generated from field: int32 max_seconds = 5;
   */
  maxSeconds: number;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive: boolean;

  /**
   * @generated from field: string payout_min_percent = 7;
   */
  payoutMinPercent: string;

  /**
   * @generated from field: string payout_max_percent = 8;
   */
  payoutMaxPercent: string;

  /**
   * @generated from field: string min_raise_points = 9;
   */
  minRaisePoints: string;

  /**
   * @generated from field: optional int32 ttl = 10;
   */
  ttl?: number;

  /**
   * @generated from field: optional string payout = 11;
   */
  payout?: string;
};

/**
 * Describes the message common.BetRuleMessage.
 * Use `create(BetRuleMessageSchema)` to create a new message.
 */
export const BetRuleMessageSchema: GenMessage<BetRuleMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 10);

/**
 * One balance that funded a trade under Multi Balance Funding (admin display).
 *
 * @generated from message common.BetFundingSourceMessage
 */
export type BetFundingSourceMessage = Message<"common.BetFundingSourceMessage"> & {
  /**
   * REAL / BONUS
   *
   * @generated from field: common.AccountType balance_type = 1;
   */
  balanceType: AccountType;

  /**
   * @generated from field: string amount = 2;
   */
  amount: string;

  /**
   * @generated from field: string share_percent = 3;
   */
  sharePercent: string;
};

/**
 * Describes the message common.BetFundingSourceMessage.
 * Use `create(BetFundingSourceMessageSchema)` to create a new message.
 */
export const BetFundingSourceMessageSchema: GenMessage<BetFundingSourceMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 11);

/**
 * @generated from message common.BetMessage
 */
export type BetMessage = Message<"common.BetMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string pair_id = 2;
   */
  pairId: string;

  /**
   * @generated from field: string symbol = 3;
   */
  symbol: string;

  /**
   * @generated from field: common.AccountType account_type = 4;
   */
  accountType: AccountType;

  /**
   * @generated from field: common.BetType bet_type = 5;
   */
  betType: BetType;

  /**
   * @generated from field: string amount = 6;
   */
  amount: string;

  /**
   * @generated from field: int32 duration_seconds = 7;
   */
  durationSeconds: number;

  /**
   * @generated from field: string min_raise_points = 8;
   */
  minRaisePoints: string;

  /**
   * @generated from field: string payout_percent = 9;
   */
  payoutPercent: string;

  /**
   * @generated from field: string entry_price = 10;
   */
  entryPrice: string;

  /**
   * @generated from field: string entry_price_ts = 11;
   */
  entryPriceTs: string;

  /**
   * @generated from field: string target_ts = 12;
   */
  targetTs: string;

  /**
   * @generated from field: optional string close_price = 13;
   */
  closePrice?: string;

  /**
   * @generated from field: optional string close_price_ts = 14;
   */
  closePriceTs?: string;

  /**
   * @generated from field: optional string settled_at = 15;
   */
  settledAt?: string;

  /**
   * @generated from field: optional common.BetOutcome outcome = 16;
   */
  outcome?: BetOutcome;

  /**
   * @generated from field: optional string profit_loss = 17;
   */
  profitLoss?: string;

  /**
   * @generated from field: common.BetLifecycle lifecycle = 18;
   */
  lifecycle: BetLifecycle;

  /**
   * @generated from field: optional common.BillingFailureReason failure_reason = 19;
   */
  failureReason?: BillingFailureReason;

  /**
   * @generated from field: string created_at = 20;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 21;
   */
  updatedAt: string;

  /**
   * @generated from field: optional string updated_by_email = 22;
   */
  updatedByEmail?: string;

  /**
   * @generated from field: optional string balance_before = 23;
   */
  balanceBefore?: string;

  /**
   * @generated from field: optional string balance_after = 24;
   */
  balanceAfter?: string;

  /**
   * Multi Balance Funding breakdown (empty for single-balance / non-bonus trades).
   *
   * @generated from field: repeated common.BetFundingSourceMessage funding_sources = 25;
   */
  fundingSources: BetFundingSourceMessage[];

  /**
   * Copy trading fields (only set when is_copy_trading_trade = true)
   *
   * @generated from field: bool is_copy_trading_trade = 26;
   */
  isCopyTradingTrade: boolean;

  /**
   * @generated from field: optional string master_trade_id = 27;
   */
  masterTradeId?: string;

  /**
   * @generated from field: optional string copied_from_trader_id = 28;
   */
  copiedFromTraderId?: string;

  /**
   * @generated from field: optional string copy_trading_subscription_id = 29;
   */
  copyTradingSubscriptionId?: string;

  /**
   * @generated from field: optional string copy_amount_calculated = 30;
   */
  copyAmountCalculated?: string;

  /**
   * @generated from field: optional string copy_amount_final = 31;
   */
  copyAmountFinal?: string;

  /**
   * @generated from field: optional string cancelled_at = 32;
   */
  cancelledAt?: string;
};

/**
 * Describes the message common.BetMessage.
 * Use `create(BetMessageSchema)` to create a new message.
 */
export const BetMessageSchema: GenMessage<BetMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 12);

/**
 * @generated from message common.BetStatsMessage
 */
export type BetStatsMessage = Message<"common.BetStatsMessage"> & {
  /**
   * @generated from field: int32 total_bets = 1;
   */
  totalBets: number;

  /**
   * @generated from field: int32 won_bets = 2;
   */
  wonBets: number;

  /**
   * @generated from field: int32 lost_bets = 3;
   */
  lostBets: number;

  /**
   * @generated from field: double win_rate = 4;
   */
  winRate: number;

  /**
   * @generated from field: double total_profit = 5;
   */
  totalProfit: number;

  /**
   * @generated from field: double avg_profit_per_bet = 6;
   */
  avgProfitPerBet: number;
};

/**
 * Describes the message common.BetStatsMessage.
 * Use `create(BetStatsMessageSchema)` to create a new message.
 */
export const BetStatsMessageSchema: GenMessage<BetStatsMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 13);

/**
 * @generated from message common.PairTtlAnalyticsMessage
 */
export type PairTtlAnalyticsMessage = Message<"common.PairTtlAnalyticsMessage"> & {
  /**
   * @generated from field: int32 ttl = 1;
   */
  ttl: number;

  /**
   * @generated from field: int32 bets = 2;
   */
  bets: number;

  /**
   * @generated from field: int32 players = 3;
   */
  players: number;

  /**
   * @generated from field: string avg_bet = 4;
   */
  avgBet: string;

  /**
   * @generated from field: string turnover = 5;
   */
  turnover: string;

  /**
   * @generated from field: string payouts = 6;
   */
  payouts: string;

  /**
   * @generated from field: string rtp = 7;
   */
  rtp: string;

  /**
   * @generated from field: string ggr = 8;
   */
  ggr: string;

  /**
   * @generated from field: string win_rate = 9;
   */
  winRate: string;

  /**
   * @generated from field: string refund_percent = 10;
   */
  refundPercent: string;

  /**
   * @generated from field: string effective_payout_percent = 11;
   */
  effectivePayoutPercent: string;

  /**
   * @generated from field: string margin_percent = 12;
   */
  marginPercent: string;

  /**
   * @generated from field: string real_ggr = 13;
   */
  realGgr: string;

  /**
   * @generated from field: string bonus_ggr = 14;
   */
  bonusGgr: string;

  /**
   * @generated from field: string win_rate_by_volume = 15;
   */
  winRateByVolume: string;

  /**
   * @generated from field: string bonus_turnover_share = 16;
   */
  bonusTurnoverShare: string;

  /**
   * @generated from field: string real_turnover = 17;
   */
  realTurnover: string;

  /**
   * @generated from field: string bonus_turnover = 18;
   */
  bonusTurnover: string;

  /**
   * @generated from field: string forfeited_amount = 19;
   */
  forfeitedAmount: string;

  /**
   * @generated from field: string win_stake = 20;
   */
  winStake: string;

  /**
   * @generated from field: string win_profit = 21;
   */
  winProfit: string;

  /**
   * @generated from field: string returned_stake = 22;
   */
  returnedStake: string;

  /**
   * @generated from field: string refund_amount = 23;
   */
  refundAmount: string;
};

/**
 * Describes the message common.PairTtlAnalyticsMessage.
 * Use `create(PairTtlAnalyticsMessageSchema)` to create a new message.
 */
export const PairTtlAnalyticsMessageSchema: GenMessage<PairTtlAnalyticsMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 14);

/**
 * @generated from message common.PairAnalyticsMessage
 */
export type PairAnalyticsMessage = Message<"common.PairAnalyticsMessage"> & {
  /**
   * @generated from field: string pair_id = 1;
   */
  pairId: string;

  /**
   * @generated from field: int32 bets = 2;
   */
  bets: number;

  /**
   * @generated from field: string avg_bet = 3;
   */
  avgBet: string;

  /**
   * @generated from field: int32 players = 4;
   */
  players: number;

  /**
   * @generated from field: string turnover = 5;
   */
  turnover: string;

  /**
   * @generated from field: string payouts = 6;
   */
  payouts: string;

  /**
   * @generated from field: string ggr = 7;
   */
  ggr: string;

  /**
   * @generated from field: string rtp = 8;
   */
  rtp: string;

  /**
   * @generated from field: string win_rate = 9;
   */
  winRate: string;

  /**
   * @generated from field: string avg_ttl = 10;
   */
  avgTtl: string;

  /**
   * @generated from field: string refund_percent = 11;
   */
  refundPercent: string;

  /**
   * @generated from field: int32 wins = 12;
   */
  wins: number;

  /**
   * @generated from field: int32 losses = 13;
   */
  losses: number;

  /**
   * @generated from field: int32 refunds = 14;
   */
  refunds: number;

  /**
   * @generated from field: int32 min_ttl = 15;
   */
  minTtl: number;

  /**
   * @generated from field: string current_payout_percent = 16;
   */
  currentPayoutPercent: string;

  /**
   * @generated from field: repeated common.PairTtlAnalyticsMessage ttl_breakdown = 17;
   */
  ttlBreakdown: PairTtlAnalyticsMessage[];

  /**
   * @generated from field: string margin_percent = 18;
   */
  marginPercent: string;

  /**
   * @generated from field: string real_ggr = 19;
   */
  realGgr: string;

  /**
   * @generated from field: string bonus_ggr = 20;
   */
  bonusGgr: string;

  /**
   * @generated from field: string win_rate_by_volume = 21;
   */
  winRateByVolume: string;

  /**
   * @generated from field: string effective_payout_percent = 22;
   */
  effectivePayoutPercent: string;

  /**
   * @generated from field: string bonus_turnover_share = 23;
   */
  bonusTurnoverShare: string;

  /**
   * @generated from field: string real_turnover = 24;
   */
  realTurnover: string;

  /**
   * @generated from field: string bonus_turnover = 25;
   */
  bonusTurnover: string;

  /**
   * @generated from field: string forfeited_amount = 26;
   */
  forfeitedAmount: string;

  /**
   * @generated from field: string win_stake = 27;
   */
  winStake: string;

  /**
   * @generated from field: string win_profit = 28;
   */
  winProfit: string;

  /**
   * @generated from field: string returned_stake = 29;
   */
  returnedStake: string;

  /**
   * @generated from field: string refund_amount = 30;
   */
  refundAmount: string;
};

/**
 * Describes the message common.PairAnalyticsMessage.
 * Use `create(PairAnalyticsMessageSchema)` to create a new message.
 */
export const PairAnalyticsMessageSchema: GenMessage<PairAnalyticsMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 15);

/**
 * @generated from message common.TickerMessage
 */
export type TickerMessage = Message<"common.TickerMessage"> & {
  /**
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * @generated from field: int64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: string price = 3;
   */
  price: string;
};

/**
 * Describes the message common.TickerMessage.
 * Use `create(TickerMessageSchema)` to create a new message.
 */
export const TickerMessageSchema: GenMessage<TickerMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 16);

/**
 * @generated from message common.CandleMessage
 */
export type CandleMessage = Message<"common.CandleMessage"> & {
  /**
   * @generated from field: int64 ts = 1;
   */
  ts: bigint;

  /**
   * @generated from field: string open = 2;
   */
  open: string;

  /**
   * @generated from field: string high = 3;
   */
  high: string;

  /**
   * @generated from field: string low = 4;
   */
  low: string;

  /**
   * @generated from field: string close = 5;
   */
  close: string;
};

/**
 * Describes the message common.CandleMessage.
 * Use `create(CandleMessageSchema)` to create a new message.
 */
export const CandleMessageSchema: GenMessage<CandleMessage> = /*@__PURE__*/
  messageDesc(file_common_trading, 17);

/**
 * @generated from message common.GetCandleHistoryRequest
 */
export type GetCandleHistoryRequest = Message<"common.GetCandleHistoryRequest"> & {
  /**
   * DDB-normalized symbol, no slash. e.g. "EURUSD" or "EURUSD.OTC".
   *
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * Timeframe as a typed enum — server maps it to the DDB ticker-key suffix
   * (e.g. TIME_FRAME_M1 → "EURUSD:1M"). UNSPECIFIED is rejected.
   *
   * @generated from field: common.TimeFrame timeframe = 2;
   */
  timeframe: TimeFrame;

  /**
   * Range in unix SECONDS (candles are always seconds-grained).
   *
   * @generated from field: int64 from_ts = 3;
   */
  fromTs: bigint;

  /**
   * @generated from field: int64 to_ts = 4;
   */
  toTs: bigint;

  /**
   * Optional cap on the response size. Server enforces its own hard maximum.
   *
   * @generated from field: optional int32 limit = 5;
   */
  limit?: number;
};

/**
 * Describes the message common.GetCandleHistoryRequest.
 * Use `create(GetCandleHistoryRequestSchema)` to create a new message.
 */
export const GetCandleHistoryRequestSchema: GenMessage<GetCandleHistoryRequest> = /*@__PURE__*/
  messageDesc(file_common_trading, 18);

/**
 * @generated from message common.GetCandleHistoryResponse
 */
export type GetCandleHistoryResponse = Message<"common.GetCandleHistoryResponse"> & {
  /**
   * @generated from field: repeated common.CandleMessage data = 1;
   */
  data: CandleMessage[];
};

/**
 * Describes the message common.GetCandleHistoryResponse.
 * Use `create(GetCandleHistoryResponseSchema)` to create a new message.
 */
export const GetCandleHistoryResponseSchema: GenMessage<GetCandleHistoryResponse> = /*@__PURE__*/
  messageDesc(file_common_trading, 19);

/**
 * @generated from enum common.AssetType
 */
export enum AssetType {
  /**
   * @generated from enum value: ASSET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_TYPE_CRYPTO = 1;
   */
  CRYPTO = 1,

  /**
   * @generated from enum value: ASSET_TYPE_FOREX = 2;
   */
  FOREX = 2,

  /**
   * @generated from enum value: ASSET_TYPE_STOCK = 3;
   */
  STOCK = 3,

  /**
   * @generated from enum value: ASSET_TYPE_INDEX = 4;
   */
  INDEX = 4,

  /**
   * @generated from enum value: ASSET_TYPE_COMMODITY = 5;
   */
  COMMODITY = 5,
}

/**
 * Describes the enum common.AssetType.
 */
export const AssetTypeSchema: GenEnum<AssetType> = /*@__PURE__*/
  enumDesc(file_common_trading, 0);

/**
 * Source of real-time price data for a pair. A pair may declare more
 * than one provider — the ticker worker subscribes to all of them
 * (groundwork for cross-exchange price averaging).
 *
 * @generated from enum common.TickerProvider
 */
export enum TickerProvider {
  /**
   * @generated from enum value: TICKER_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TICKER_PROVIDER_TWELVEDATA = 2;
   */
  TWELVEDATA = 2,

  /**
   * @generated from enum value: TICKER_PROVIDER_OKX = 3;
   */
  OKX = 3,

  /**
   * @generated from enum value: TICKER_PROVIDER_ITICK = 4;
   */
  ITICK = 4,

  /**
   * @generated from enum value: TICKER_PROVIDER_FXCM = 5;
   */
  FXCM = 5,
}

/**
 * Describes the enum common.TickerProvider.
 */
export const TickerProviderSchema: GenEnum<TickerProvider> = /*@__PURE__*/
  enumDesc(file_common_trading, 1);

/**
 * Provider-specific region/venue selector. Today only iTick uses it:
 *   - GB is the only forex venue iTick documents
 *     (https://docs.itick.org/websocket/forex)
 *   - BA / BT / PB are crypto venues (Binance / Bybit / OKX) per
 *     https://docs.itick.org/websocket/crypto
 * Other providers ignore the region; admin UI hides the selector
 * when the provider doesn't expose a choice.
 *
 * @generated from enum common.TickerProviderRegion
 */
export enum TickerProviderRegion {
  /**
   * @generated from enum value: TICKER_PROVIDER_REGION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TICKER_PROVIDER_REGION_GB = 1;
   */
  GB = 1,

  /**
   * @generated from enum value: TICKER_PROVIDER_REGION_BA = 2;
   */
  BA = 2,

  /**
   * @generated from enum value: TICKER_PROVIDER_REGION_BT = 3;
   */
  BT = 3,

  /**
   * @generated from enum value: TICKER_PROVIDER_REGION_PB = 4;
   */
  PB = 4,
}

/**
 * Describes the enum common.TickerProviderRegion.
 */
export const TickerProviderRegionSchema: GenEnum<TickerProviderRegion> = /*@__PURE__*/
  enumDesc(file_common_trading, 2);

/**
 * @generated from enum common.BetType
 */
export enum BetType {
  /**
   * @generated from enum value: BET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_TYPE_CALL = 1;
   */
  CALL = 1,

  /**
   * @generated from enum value: BET_TYPE_PUT = 2;
   */
  PUT = 2,
}

/**
 * Describes the enum common.BetType.
 */
export const BetTypeSchema: GenEnum<BetType> = /*@__PURE__*/
  enumDesc(file_common_trading, 3);

/**
 * @generated from enum common.BetCalcMode
 */
export enum BetCalcMode {
  /**
   * @generated from enum value: BET_CALC_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_CALC_MODE_FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: BET_CALC_MODE_LINEAR = 2;
   */
  LINEAR = 2,

  /**
   * @generated from enum value: BET_CALC_MODE_STEP = 3;
   */
  STEP = 3,

  /**
   * @generated from enum value: BET_CALC_MODE_FORMULA = 4;
   */
  FORMULA = 4,
}

/**
 * Describes the enum common.BetCalcMode.
 */
export const BetCalcModeSchema: GenEnum<BetCalcMode> = /*@__PURE__*/
  enumDesc(file_common_trading, 4);

/**
 * @generated from enum common.BetTimeMode
 */
export enum BetTimeMode {
  /**
   * @generated from enum value: BET_TIME_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_TIME_MODE_PREDEFINED = 1;
   */
  PREDEFINED = 1,

  /**
   * @generated from enum value: BET_TIME_MODE_CUSTOM = 2;
   */
  CUSTOM = 2,

  /**
   * @generated from enum value: BET_TIME_MODE_FIXED = 3;
   */
  FIXED = 3,
}

/**
 * Describes the enum common.BetTimeMode.
 */
export const BetTimeModeSchema: GenEnum<BetTimeMode> = /*@__PURE__*/
  enumDesc(file_common_trading, 5);

/**
 * @generated from enum common.BetLifecycle
 */
export enum BetLifecycle {
  /**
   * @generated from enum value: BET_LIFECYCLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_LIFECYCLE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: BET_LIFECYCLE_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: BET_LIFECYCLE_SCHEDULED = 3;
   */
  SCHEDULED = 3,

  /**
   * @generated from enum value: BET_LIFECYCLE_SETTLED = 4;
   */
  SETTLED = 4,

  /**
   * @generated from enum value: BET_LIFECYCLE_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum common.BetLifecycle.
 */
export const BetLifecycleSchema: GenEnum<BetLifecycle> = /*@__PURE__*/
  enumDesc(file_common_trading, 6);

/**
 * @generated from enum common.BetOutcome
 */
export enum BetOutcome {
  /**
   * @generated from enum value: BET_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_OUTCOME_WON = 1;
   */
  WON = 1,

  /**
   * @generated from enum value: BET_OUTCOME_LOST = 2;
   */
  LOST = 2,

  /**
   * @generated from enum value: BET_OUTCOME_RETURNED = 3;
   */
  RETURNED = 3,
}

/**
 * Describes the enum common.BetOutcome.
 */
export const BetOutcomeSchema: GenEnum<BetOutcome> = /*@__PURE__*/
  enumDesc(file_common_trading, 7);

/**
 * @generated from enum common.PairGroupMode
 */
export enum PairGroupMode {
  /**
   * @generated from enum value: PAIR_GROUP_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAIR_GROUP_MODE_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: PAIR_GROUP_MODE_SHADOW = 2;
   */
  SHADOW = 2,

  /**
   * @generated from enum value: PAIR_GROUP_MODE_ON = 3;
   */
  ON = 3,
}

/**
 * Describes the enum common.PairGroupMode.
 */
export const PairGroupModeSchema: GenEnum<PairGroupMode> = /*@__PURE__*/
  enumDesc(file_common_trading, 8);

/**
 * Balance slices included in analytics. UNSPECIFIED is interpreted as TRADING.
 *
 * @generated from enum common.BalanceScope
 */
export enum BalanceScope {
  /**
   * @generated from enum value: BALANCE_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BALANCE_SCOPE_TRADING = 1;
   */
  TRADING = 1,

  /**
   * @generated from enum value: BALANCE_SCOPE_REAL = 2;
   */
  REAL = 2,

  /**
   * @generated from enum value: BALANCE_SCOPE_BONUS = 3;
   */
  BONUS = 3,

  /**
   * @generated from enum value: BALANCE_SCOPE_PARTNER = 4;
   */
  PARTNER = 4,

  /**
   * @generated from enum value: BALANCE_SCOPE_DEMO = 5;
   */
  DEMO = 5,
}

/**
 * Describes the enum common.BalanceScope.
 */
export const BalanceScopeSchema: GenEnum<BalanceScope> = /*@__PURE__*/
  enumDesc(file_common_trading, 9);

/**
 * @generated from enum common.PayoutCalcMode
 */
export enum PayoutCalcMode {
  /**
   * @generated from enum value: PAYOUT_CALC_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYOUT_CALC_MODE_FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: PAYOUT_CALC_MODE_LINEAR = 2;
   */
  LINEAR = 2,

  /**
   * @generated from enum value: PAYOUT_CALC_MODE_STEP = 3;
   */
  STEP = 3,

  /**
   * @generated from enum value: PAYOUT_CALC_MODE_FORMULA = 4;
   */
  FORMULA = 4,
}

/**
 * Describes the enum common.PayoutCalcMode.
 */
export const PayoutCalcModeSchema: GenEnum<PayoutCalcMode> = /*@__PURE__*/
  enumDesc(file_common_trading, 10);

/**
 * TimeFrame — values are the duration in SECONDS so the enum doubles as a
 * machine-readable interval. `TimeFrame.M1 === 60`, `TimeFrame.H1 === 3600`,
 * etc. Sparse values are intentional and shared with the backend's internal
 * alignment/bucketing logic.
 *
 * @generated from enum common.TimeFrame
 */
export enum TimeFrame {
  /**
   * @generated from enum value: TIME_FRAME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_FRAME_S1 = 1;
   */
  S1 = 1,

  /**
   * @generated from enum value: TIME_FRAME_S5 = 5;
   */
  S5 = 5,

  /**
   * @generated from enum value: TIME_FRAME_S10 = 10;
   */
  S10 = 10,

  /**
   * @generated from enum value: TIME_FRAME_S15 = 15;
   */
  S15 = 15,

  /**
   * @generated from enum value: TIME_FRAME_S30 = 30;
   */
  S30 = 30,

  /**
   * @generated from enum value: TIME_FRAME_M1 = 60;
   */
  M1 = 60,

  /**
   * @generated from enum value: TIME_FRAME_M2 = 120;
   */
  M2 = 120,

  /**
   * @generated from enum value: TIME_FRAME_M3 = 180;
   */
  M3 = 180,

  /**
   * @generated from enum value: TIME_FRAME_M5 = 300;
   */
  M5 = 300,

  /**
   * @generated from enum value: TIME_FRAME_M10 = 600;
   */
  M10 = 600,

  /**
   * @generated from enum value: TIME_FRAME_M15 = 900;
   */
  M15 = 900,

  /**
   * @generated from enum value: TIME_FRAME_M30 = 1800;
   */
  M30 = 1800,

  /**
   * @generated from enum value: TIME_FRAME_M45 = 2700;
   */
  M45 = 2700,

  /**
   * @generated from enum value: TIME_FRAME_H1 = 3600;
   */
  H1 = 3600,

  /**
   * @generated from enum value: TIME_FRAME_H2 = 7200;
   */
  H2 = 7200,

  /**
   * @generated from enum value: TIME_FRAME_H3 = 10800;
   */
  H3 = 10800,

  /**
   * @generated from enum value: TIME_FRAME_H4 = 14400;
   */
  H4 = 14400,

  /**
   * @generated from enum value: TIME_FRAME_H6 = 21600;
   */
  H6 = 21600,

  /**
   * @generated from enum value: TIME_FRAME_H8 = 28800;
   */
  H8 = 28800,

  /**
   * @generated from enum value: TIME_FRAME_H12 = 43200;
   */
  H12 = 43200,

  /**
   * @generated from enum value: TIME_FRAME_D1 = 86400;
   */
  D1 = 86400,

  /**
   * @generated from enum value: TIME_FRAME_W1 = 604800;
   */
  W1 = 604800,

  /**
   * @generated from enum value: TIME_FRAME_MN1 = 2592000;
   */
  MN1 = 2592000,

  /**
   * @generated from enum value: TIME_FRAME_Y1 = 31536000;
   */
  Y1 = 31536000,
}

/**
 * Describes the enum common.TimeFrame.
 */
export const TimeFrameSchema: GenEnum<TimeFrame> = /*@__PURE__*/
  enumDesc(file_common_trading, 11);

/**
 * Chart history — exposed to both client and admin apps. Replaces the WS-based
 * history flow that previously ran through `cronika-lambdas/StockWebsocketHandler`.
 *
 * @generated from service common.ChartRPCService
 */
export const ChartRPCService: GenService<{
  /**
   * @generated from rpc common.ChartRPCService.GetCandleHistory
   */
  getCandleHistory: {
    methodKind: "unary";
    input: typeof GetCandleHistoryRequestSchema;
    output: typeof GetCandleHistoryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_common_trading, 0);

